import React, { useState } from 'react';
import { EReceptRow } from '../../../../Components/eRecept/List/EReceptListItem';
// @ts-ignore
import styles from './P1PrescriptionListItem.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import { prepareDocumentationFileForMediaViewer } from '../../../Ecard/Services/eCardFile.service';
import { useAppContext } from '../../../../Services/AppContext';
import Text from '../../../../Components/Base/Text/Text';
import P1PrescriptionCancelModal from '../P1PrescriptionCancel/P1PrescriptionCancelModal';

interface Props {
	item: EReceptRow;
	onDelete: () => void;
}

const P1PrescriptionListItem: React.FC<Props> = ({ item, onDelete }) => {
	const { socketUrl } = useAppContext();
	const [isDetailOpen, setIsDetailOpen] = useState(false);
	const [isCancelOpen, setIsCancelOpen] = useState(false);

	const handleOnDelete = () => {
		setIsCancelOpen(false);
		onDelete();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.date}>
					<FormattedMomentDate
						date={item.createdAt}
						format={DateFormat.DATE_TIME}
					/>
				</div>
				<div className={styles.content}>
					{item.items?.map((medicament, index) => (
						<div className={styles.title} key={index}>
							{medicament.prescriptionMedicament.name}
						</div>
					))}
					{item.cancelledAt && item.cancelledByName && (
						<div className={styles.cancelInfo}>
							<FormattedMomentDate
								date={item.cancelledAt}
								format={DateFormat.DATE_TIME}
							/>
							<Text tx='base.canceledBy' colon />
							{item.cancelledByName}
						</div>
					)}
					{item.data?.cancelationNote && (
						<div className={styles.cancelInfo}>
							<Text tx='base.shared.note' colon />
							{item.data.cancelationNote}
						</div>
					)}
				</div>
				<div className={styles.controls}>
					{item.documentationFile && (
						<LinkButton
							title='component.ePrescription.detail'
							theme={Theme.BLUE}
							onClick={() => setIsDetailOpen(true)}
						/>
					)}
					{item.isCancelable && (
						<LinkButton
							title='base.shared.cancel'
							theme={Theme.RED}
							onClick={() => setIsCancelOpen(true)}
						/>
					)}
				</div>
			</div>
			{isDetailOpen && item.documentationFile && (
				<MediaViewerModal
					opened
					onClose={() => setIsDetailOpen(false)}
					file={prepareDocumentationFileForMediaViewer(
						item.documentationFile,
						socketUrl,
					)}
					isSignable={item.documentationFile.canBeSigned || false}
				/>
			)}
			{isCancelOpen && (
				<P1PrescriptionCancelModal
					isOpen
					item={item}
					onClose={() => setIsCancelOpen(false)}
					onSuccess={handleOnDelete}
				/>
			)}
		</>
	);
};

export default P1PrescriptionListItem;
